import { Bones, Heading, Grid } from '@simplywallst/ui-core';
import { Wrapper } from '@/components/Search/components/DefaultState/styled';

const LoadingDefaultState = () => (
  <Wrapper>
    <Heading as="h3" typography="smallStrong" color="white">
      Trending Stocks
    </Heading>
    <Grid templateColumns="1fr 1fr 1fr 1fr" gap="2px">
      <Bones minHeight="106px" />
      <Bones minHeight="106px" />
      <Bones minHeight="106px" />
      <Bones minHeight="106px" />
    </Grid>
    <Heading as="h3" typography="smallStrong" color="white">
      Trending Ideas
    </Heading>
    <Grid templateColumns="1fr 1fr 1fr" gap="2px">
      <Bones minHeight="122px" />
      <Bones minHeight="122px" />
      <Bones minHeight="122px" />
    </Grid>
  </Wrapper>
);

export default LoadingDefaultState;
